import { RootState } from '@/store/reducers';

export const selectCurrentMetricLocalization = ({ metricLocalization }: RootState) => metricLocalization.metricLocalization;
